<template>
  <div class="content-funding col-12 col-xs-12">
    <!-- chart here -->
    <div class="content-funding__chart">
      <!-- chart header -->
      <div v-if="content.chart" class="row" style="padding-top: 0">
        <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 offset-md-2 offset-sm-1">
          <h3>{{ content.chart.title }}</h3>

          <p>
            {{ content.chart.instruction }}
          </p>
        </div>
      </div>

      <!-- chart controls and viz -->
      <FundingDealsViz />

      <!-- footer -->
      <div class="funding-chart__footer text-center">
        <p class="text-small">
          <i>*Deals with undisclosed amounts are not included in the total funding count.</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fundings',
  components: {
    FundingDealsViz: () => import('@/components/content/charts/FundingDealsViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.content-funding {
  .content-funding__intro {
    padding: 60px 0;

    .funding-intro__prelude {
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  .content-funding__chart {
    padding: 60px 0;
    background-color: #fff;
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    .content-funding__intro {
      padding: 30px 0;
    }

    .content-funding__chart {
      padding: 30px 0;
    }
  }
}
</style>
